// extracted by mini-css-extract-plugin
export default {"trafficFilter":"VehicleTrafficEntriesFilter_trafficFilter__XRcGv","bufferSizeField":"VehicleTrafficEntriesFilter_bufferSizeField__NzCxs"};